import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-home-index',
  templateUrl: './home-index.component.html',
  styleUrls: ['./home-index.component.css']
})
export class HomeIndexComponent implements OnInit {

  constructor() { }

  ngOnInit() {
    // $(document).ready(function () {
    //   $('.flexslider').flexslider({
    //     animation: "slide",
    //     animationLoop: false,
    //     itemWidth: 216,
    //     itemMargin: 5
    //   });
    // });
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/login/home-index/home-index.component.ts